export enum ModalStatusTypes {
  OPEN,
  CLOSED,
}
